<template>
    <LoginLayout>
        <div class="mb-0 LoginCard">

            <div v-if="!isValidRequest" class="alert alert-danger bg-danger">
                {{$t('auth.invalid_request')}}
            </div>

            <LoginForm
                v-else-if="!isAuthenticated"
            />

            <h4 class="my-5 waiting-title text-white" v-else-if="generatingAccessToApplication">
                <i class="fa fa-circle-o-notch fa-spin mr-2"></i> {{$t('auth.login_to_application')}}
            </h4>

            <div v-if="generatingAccessError" class="alert alert-danger bg-danger">
                {{ generatingAccessError }}
            </div>

        </div>
    </LoginLayout>
</template>

<script>

import LoginLayout from "../../../views/layouts/LoginLayout";
import LoginForm from "@/components/Auth/LoginForm.vue";
import oauth2RequiredParams from "@/modules/Auth/policy/oauth2RequiredParams";
import {logIntoApplication} from "@/modules/Auth/service/oauthService";
import {fetchApplicationFromContext} from "@/services/OpenApiService";
import SystemNotificator from "@/services/SystemNotificator";
import {missingAccessToApplicationModal} from "@/modules/Auth/service/missingAccessToApplicationService";
export default {
    name: "Oauth2",
    components: {
        LoginForm,
        LoginLayout
    },

    data() {
        return {
            generatingAccessToApplication: false,
            application: null,
            generatingAccessError: null
        }
    },

    beforeRouteEnter(to, from, next) {
        return fetchApplicationFromContext(to.query.client_id)
            .then(({data}) => {
                next(vm => {
                    vm.application = data.data;
                })
            }).catch(() => SystemNotificator.error({message: this.$t('auth.application_not_found')}));
    },

    computed: {
        query() {
            return this.$route.query;
        },

        oauthParams() {
            return {
                clientId: this.query.client_id,
                state: this.query.state,
                redirectUri: this.query.redirect_uri,
                responseType: this.query.response_type,
                scopes:  this.query.scope.split(' '),
                scope: this.query.scope
            }
        },

        isSupportedResponseType() {
            return this.oauthParams.responseType === 'code';
        },

        isValidRequest() {
            return oauth2RequiredParams(this.oauthParams) && this.isSupportedResponseType;
        },

        isAuthenticated() {
            return this.$store.state.Auth.isAuthenticated;
        },

        isGrantedAccess() {
            return this.$store.state.Auth.applications.filter(el => el.uuid === this.application.uuid).length > 0;
        },

    },

    watch: {
        isAuthenticated: {
            immediate: true,
            handler: async function(authenticated){
                // Jeśli nie jest zalogowany to nic nie robimy
                if (! authenticated || ! this.isValidRequest) {
                    return;
                }

                this.generatingAccessToApplication = true;
                await this.$store.dispatch('Auth/fetchApplications')

                if (! this.isGrantedAccess) {
                    await missingAccessToApplicationModal(this.application);
                }

                return logIntoApplication(this.oauthParams)
                    .catch(() => {
                        this.generatingAccessError = this.$t('auth.generating_access_to_application_error');
                        this.generatingAccessToApplication = false;
                    })
            }
        }
    }

}
</script>